import React from 'react';

import { getAsset } from '../../../util/assets';
import Button from '../Button';
import useOpenModal from '../../../hooks/useOpenModal';
import getConfig from '../../../util/config';
import LogoPoweredBy from '../LogoPoweredBy';
import { QR_CODE_MODAL } from '../QRCodeModal';

const AppDownloadQRUpsell = () => {
  const config = getConfig();

  const openModal = useOpenModal();

  const appDownloadTitle =
    'Scan this QR code to download Waldo on your mobile!';

  return (
    <div className="app-download-qr-upsell d-none d-lg-flex">
      <div className="app-store-links">
        <Button
          onClick={() => {
            openModal(QR_CODE_MODAL, {
              title: appDownloadTitle,
              QRCodeValue: config.mobile.iosAppUrl,
            });
          }}
          btnStyle="reset"
          className="mr-1"
        >
          <img src={getAsset('/app-store-logo-1.svg')} alt="App Store logo" />
        </Button>
        <Button
          onClick={() => {
            openModal(QR_CODE_MODAL, {
              title: appDownloadTitle,
              QRCodeValue: config.mobile.androidAppUrl,
            });
          }}
          btnStyle="reset"
        >
          <img src={getAsset('/play-store-logo-1.svg')} alt="Play Store logo" />
        </Button>
      </div>

      <LogoPoweredBy className="ml-auto" />
    </div>
  );
};

export default AppDownloadQRUpsell;
